import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApproveAppGovernancePermissionsMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { useApp } from '../../contexts/AppContext';
import { useDataPermissions } from '../../contexts/DataPermissionsContext';
import { useInstallPermissions } from '../../contexts/InstallPermissionsContext';
import { useCaptureError } from '../useCaptureError';
import { jsx as _jsx } from "react/jsx-runtime";
const ERROR_CONFIG = {
  message: 'Error approving app governance permissions',
  alert: {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.errorBoundary.default.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.approveAppPanel.error"
    })
  }
};
const getPermissionId = permission => permission.id;
export function useApproveAppGovernance() {
  const {
    appId
  } = useApp();
  const {
    getCheckedOptionalPermissions,
    getCheckedConditionallyRequiredPermissions
  } = useDataPermissions();
  const {
    installPermissionAccessState,
    getSelectedEntityTypeAndIds
  } = useInstallPermissions();
  const [approveAppMutation, {
    loading,
    error
  }] = useApproveAppGovernancePermissionsMutation();
  useCaptureError(error, ERROR_CONFIG);
  const approveApp = async () => {
    const optionalAppPermissionIds = getCheckedOptionalPermissions().map(getPermissionId);
    const conditionallyRequiredAppPermissionIds = getCheckedConditionallyRequiredPermissions().map(getPermissionId);
    const isSpecificUsersAndTeams = installPermissionAccessState === 'SPECIFIC_USERS_AND_TEAMS';
    const entityTypeAndIds = isSpecificUsersAndTeams ? getSelectedEntityTypeAndIds() : [];
    return await approveAppMutation({
      variables: {
        appId,
        installPermissionAccessState,
        optionalAppPermissions: optionalAppPermissionIds,
        conditionallyRequiredAppPermissions: conditionallyRequiredAppPermissionIds,
        entityTypeAndIds
      }
    });
  };
  return {
    approveApp,
    loading,
    error
  };
}